import React from "react";
import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core"; // add this import

const isNative = Capacitor.isNativePlatform?.() || false;
const platform = isNative ? Capacitor.getPlatform() : null;
const ua = (typeof navigator !== "undefined" ? navigator.userAgent : "").toLowerCase();

const isIOS = platform === "ios" || /iphone|ipad|ipod|ios/.test(ua);
const isAndroid = platform === "android" || /android/.test(ua);

const IOS_HTTP = "https://apps.apple.com/us/app/strike-bitcoin/id1488724463";
const ANDROID_HTTP = "https://play.google.com/store/apps/details?id=zapsolutions.strike";

export default function Learn() {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-8">
        <h1 className="text-3xl font-bold mb-2 text-gray-900 text-center">
          New to Bitcoin?
        </h1>
        <p className="text-gray-600 text-center mb-8">
          A 2-minute intro to Bitcoin and how SatStacker automates your buys.
        </p>

        {/* Step 1 */}
        <div className="bg-gray-100 border border-gray-200 rounded-xl p-5 mb-4">
          <h2 className="font-semibold text-gray-900 mb-1">1) What is Bitcoin?</h2>
          <p className="text-gray-700">
            Bitcoin is digital money that runs on a decentralized network, which means no banks or middlemen.
            It’s scarce (only 21 million will ever exist), borderless, and can be sent or stored
            securely anywhere in the world. Many people accumulate Bitcoin over time as a long-term
            savings strategy.
          </p>
        </div>

        {/* Step 2 */}
        <div className="bg-gray-100 border border-gray-200 rounded-xl p-5 mb-4">
          <h2 className="font-semibold text-gray-900 mb-1">2) How SatStacker Works</h2>
          <p className="text-gray-700">
            SatStacker connects securely to your <strong>Strike</strong> account to automate
            recurring Bitcoin purchases. You choose an amount (e.g., $10 weekly), and our
            <strong> Smart Timing</strong> looks for favorable prices inside each buy window.
            Purchases execute through your connected Strike account; SatStacker itself never holds
            your cash or Bitcoin.
          </p>
        </div>

        {/* Step 3 */}
        <div className="bg-gray-100 border border-gray-200 rounded-xl p-5 mb-6">
        <h2 className="font-semibold text-gray-900 mb-1">3) Safety & Getting Started</h2>
        <div className="text-gray-700 space-y-3">
            <p className="mb-2">
            <strong>First:</strong> Download <strong>Strike</strong> and create an account. Connect your bank
            so you can fund your automated Bitcoin purchases.
            </p>
            <ul className="list-disc list-inside ml-4">
                {isIOS && (
                    <li>
                    iOS: <a href={IOS_HTTP} className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">
                        App Store
                    </a>
                    </li>
                )}
                {isAndroid && (
                    <li>
                    Android: <a href={ANDROID_HTTP} className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">
                        Google Play
                    </a>
                    </li>
                )}
                {!isIOS && !isAndroid && (
                    <>
                    <li>
                        iOS: <a href={IOS_HTTP} className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">
                        App Store
                        </a>
                    </li>
                    <li>
                        Android: <a href={ANDROID_HTTP} className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">
                        Google Play
                        </a>
                    </li>
                    </>
                )}
            </ul>

            <p className="mt-2">
            <strong>Next:</strong> Create your SatStacker account, connect Strike, set your plan
            amount, and you’re done. Let <strong>SatStacker’s Smart Timing</strong> do the
            work over time.
            </p>

            <p className="text-sm text-gray-600">
            Safety tips: use a wallet you control, back up your recovery phrase, and verify your payout
            address when you change it. Start small while you get comfortable.
            </p>
        </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/signup" className="bg-blue-600 text-white px-6 py-2 rounded-xl hover:bg-blue-700 text-center">
            Create an Account
          </Link>
          <Link to="/pricing" className="bg-gray-900 text-white px-6 py-2 rounded-xl hover:bg-black text-center">
            See Pricing
          </Link>
          <Link to="/faq" className="bg-white border border-gray-300 text-gray-900 px-6 py-2 rounded-xl hover:bg-gray-50 text-center">
            Read FAQs
          </Link>
        </div>

        <p className="text-center text-gray-500 text-sm mt-6">
          Already have a Strike account? You can connect it after signup.
        </p>
      </div>
    </div>
  );
}
